/* eslint-disable @next/next/no-img-element */
import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";

import styles from "./InniBlock.module.css";
import "swiper/css";

import { openInNewTab } from "@/components/shared/utils";
import { Mixpanel } from "@/helpers/mixpanel";
import { useAuth } from "@/context/AuthContext";
import {
  DASHBOARD_INNI_PREVIEW_ID,
  scrollToInniPreviewView,
  VIEW_DASHBOARD_INNI_CTA,
} from "./scrollToInniPreview";

export default function InniBlock() {
  const [mySwiperRef, setMySwiperRef] = useState<any>(null);

  const [index, setIndex] = useState<number>(0);
  const fillArray = [0, 1, 2, 3, 4, 5, 6];

  useEffect(() => {
    if (mySwiperRef) mySwiperRef?.slideTo(index);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [index]);

  useEffect(() => {
    if (localStorage.getItem(VIEW_DASHBOARD_INNI_CTA)) {
      scrollToInniPreviewView();
    }
  }, []);

  const mapped = [
    <SlideOne key={0} />,
    <SlideSeven key={1} />,
    <SlideTwo key={2} />,
    <SlideThree key={3} />,
    <SlideFour key={4} />,
    <SlideFive key={5} />,
    <SlideSix key={6} />,
  ].map((c, i) => {
    return <SwiperSlide key={i}>{c}</SwiperSlide>;
  });

  const mappedDots = fillArray.map((dot) => {
    return (
      <div
        className={styles.dot}
        style={{ opacity: index === dot ? 1 : 0.35 }}
        key={dot}
      ></div>
    );
  });

  return (
    <div id={DASHBOARD_INNI_PREVIEW_ID} className={styles.main}>
      <div className={styles.wrapper}>
        <Swiper
          min-height={391}
          autoHeight={false}
          nested={true}
          slidesPerView={1}
          touchReleaseOnEdges={true}
          onSlideChange={(e) => {
            setIndex(e.activeIndex);
          }}
          scrollbar={{ draggable: true }}
          threshold={1}
          onSwiper={setMySwiperRef}
        >
          {mapped}
        </Swiper>
      </div>
      <div className={styles.dotWrapper}>{mappedDots}</div>
    </div>
  );
}

function SlideOne() {
  const { user } = useAuth();

  const handleClick = () => {
    Mixpanel?.track(
      "INNI download CTA pressed",
      {
        source: "dashboard component",
      },
      user?.uid
    );
    
    if (window.Android) {
      window.Android.openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    } else {
      openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    }
  };

  return (
    <div className={styles.slideContianerOne}>
      <img src="/inni/icon.png" alt="" className={styles.icon} />
      <h2 style={{ marginTop: "21px" }} className={styles.title}>
        {"Try INNI"}
      </h2>
      <h3 style={{ marginTop: "21px" }} className={styles.subTitle}>
        {"More than a dating app."}
      </h3>
      <h3 style={{ marginTop: "2px" }} className={styles.subTitle}>
        {"Understand your patterns. Clarify your needs."}
      </h3>
      <h3 style={{ marginTop: "2px" }} className={styles.subTitle}>
        {"Explore your compatibility with anyone."}
      </h3>
      <h3 style={{ marginTop: "27px" }} className={styles.subTitle}>
        Built by <span style={{ color: "#FFFFF2" }}>Dimensional</span>
      </h3>
      <button
        onClick={handleClick}
        style={{ marginTop: "14px" }}
        className={styles.btn}
      >
        Download on the PlayStore
      </button>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="32"
        height="16"
        viewBox="0 0 32 16"
        fill="none"
        style={{ marginTop: "auto" }}
      >
        <path
          d="M30.747 8.74702C31.1596 8.33445 31.1596 7.66555 30.747 7.25298L24.0239 0.529824C23.6113 0.117257 22.9424 0.117257 22.5298 0.529824C22.1173 0.94239 22.1173 1.61129 22.5298 2.02386L28.506 8L22.5298 13.9761C22.1173 14.3887 22.1173 15.0576 22.5298 15.4702C22.9424 15.8827 23.6113 15.8827 24.0239 15.4702L30.747 8.74702ZM0 8L-9.23572e-08 9.05644L30 9.05645L30 8L30 6.94356L9.23572e-08 6.94356L0 8Z"
          fill="#FFFFF2"
        />
      </svg>
    </div>
  );
}

function SlideTwo() {
  return (
    <div className={styles.slideContianerTwo}>
      <h2 className={styles.title}>Clarify your needs and patterns</h2>
      <img className={styles.image} src="/inni/slideOneImage.png" alt="" />
    </div>
  );
}

function SlideThree() {
  return (
    <div className={styles.slideContianerTwo}>
      <h2 className={styles.title}>Know your compatibility</h2>
      <img className={styles.image} src="/inni/slideTwoImage.png" alt="" />
    </div>
  );
}

function SlideFour() {
  return (
    <div style={{ paddingTop: "14px" }} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>{"Explore what's important to you"}</h2>
      <img className={styles.image} src="/inni/slideThreeImage.png" alt="" />
    </div>
  );
}

function SlideFive() {
  return (
    <div style={{ paddingTop: "14px" }} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>{"Ask inni about your match"}</h2>
      <img className={styles.image} src="/inni/slideFourImage.png" alt="" />
    </div>
  );
}

function SlideSix() {
  const { user } = useAuth();

  const handleClick = () => {
    Mixpanel?.track(
      "INNI download CTA pressed",
      {
        source: "dashboard component",
      },
      user?.uid
    );
    if (window.Android) {
      window.Android.openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    } else {
      openInNewTab(
        "https://play.google.com/store/apps/details?id=com.dimensional.inni"
      );
    }
  };

  return (
    <div className={styles.slideContianerOne}>
      <h2
        style={{ marginTop: "103px", maxWidth: "299px" }}
        className={styles.title}
      >
        {"Date better."}
      </h2>
      <button
        onClick={handleClick}
        style={{ marginTop: "auto" }}
        className={styles.btn}
      >
        Download on Google Play
      </button>
    </div>
  );
}

function SlideSeven() {
  return (
    <div style={{ paddingTop: "14px" }} className={styles.slideContianerTwo}>
      <h2 className={styles.title}>{"Import your Dimensional profile"}</h2>
      <img className={styles.image} src="/inni/slideSevenImage.png" alt="" />
    </div>
  );
}